import { Component, input } from '@angular/core';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { HrefDirective, HrefParams } from '../../directives/href/href.directive';
import { HrefPipe } from '../../pipes/href.pipe';
import { IconComponent } from '../../components/icon/icon.component';

@Component({
  selector: 'td-wb-unsupported',
  templateUrl: 'unsupported.component.html',
  styleUrls: ['unsupported.component.scss'],
  imports: [
    HrefDirective,
    TranslateDirective,
    TranslatePipe,
    HrefPipe,
    IconComponent
  ]
})
export class UnsupportedBrowserComponent {
  readonly to = input<string>(undefined);
  readonly params = input<HrefParams>(undefined);
}
